export enum LineOfBusinessTypes {
  Home = 'Home',
  Motor = 'Motor',
}

export enum ClaimStatusTypes {
  Open = 'Open',
  Closed = 'Closed',
  New = 'New',
}
